/* eslint-disable consistent-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { AutoComplete } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const { Option } = AutoComplete;

export default function AsyncAutoComplete({
  // properties
  style,
  placeholder,
  options,
  disabled,
  loading,

  // methods
  onInputSelect,
  onFocus,
}) {
  const renderLoading = () => {
    if (!loading) {
      return;
    }
    return <LoadingOutlined style={{ fontSize: 24 }} spin />;
  };

  const renderOptions = () => options.map(({ value: val, label }, index) => (
    <Option key={index} value={val}>
      {label}
    </Option>
  ));

  return (() => (
    <>
      <AutoComplete
          // properties
        style={{
          width: '100%',
          ...style,
        }}
        placeholder={placeholder}
        backfill
        disabled={loading || disabled}
        notFoundContent="Option not found"
        onSelect={onInputSelect}
        onFocus={onFocus}
        filterOption
      >
        {renderOptions()}
      </AutoComplete>
      {renderLoading()}
    </>
  ))();
}
